













import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import UploadForm from '@/views/exam/components/Upload.vue'
import { uploadUsers } from '@/api/springexam/springexamuser'

@Component({
  components: { UploadForm }
})
export default class UserUploader extends Vue {
  @Prop({ type: String, required: true }) examId!: string
  @Prop({ type: String, required: true }) examName!: string

  handleUploadRoom = uploadUsers

  @Emit('clickReturn')
  onReturn($event: any) {
    return $event
  }

  @Emit('uploadSuccess')
  handleSuccess($event: any) {
    return $event
  }
}
